<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <div class="bg-white poppins">
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">{{ label }}</h4>
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
      </div>
      <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
        <!--begin::Body-->
        <div class="">
          <v-alert
            dense
            border="left"
            type="warning"
            dismissible
            v-if="exampleFile.need_to_show_message"
          >
            <span v-html="exampleFile.message"></span>
          </v-alert>
        </div>
        <v-card elevation="0" class="mb-4">
          <form id="createForm" class="pa-3 text-center">
            <v-file-input
              v-model="formData.file"
              :label="$t('file_input')"
              outlined
              dense
              :error-messages="fileErrors"
              @input="$v.formData.file.$touch()"
              @blur="$v.formData.file.$touch()"
            ></v-file-input>
            <!-- add example file -->
            <v-btn class="primary--text" outlined text :href="exampleFile.url">
              {{ $t("download_template") }}
            </v-btn>
            <v-main class="text-center mt-4">
              <button
                type="button"
                class="btn btn-info px-5 py-3 ls1"
                @click.prevent="submitEditForm"
              >
                {{ $t("import") }}
              </button>
            </v-main>
          </form>
        </v-card>
        <!--end::Body-->
      </div>
    </div>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

export default {
  name: "ImportData",
  mixins: [validationMixin],
  validations: {
    formData: {
      file: { required },
    },
  },
  props: ["label", "setData", "customer"],
  data: () => ({
    dialog: false,

    formData: {
      file: null,
    },
  }),
  methods: {
    handleFormValidation(fieldName, vueObj) {
      const errors = [];
      if (!vueObj.$v.formData[fieldName].$dirty) return errors;
      // if ("email" in vueObj.$v[fieldName]) {
      //   !vueObj.$v[fieldName].email &&
      //     errors.push("This email address is invalid");
      // }
      if ("required" in vueObj.$v.formData[fieldName]) {
        !vueObj.$v.formData[fieldName].required &&
          errors.push(vueObj.$t("validation_this_field_is_required"));
      }
      return errors;
    },
    toggleModal() {
      if (this.dialog) {
        this.resetEditForm();
      }
      this.dialog = !this.dialog;
    },
    validateData() {
      return true;
    },
    convertToFormData() {
      let data = new FormData();
      data.append("file", this.formData.file, this.formData.file.name);
      if (this.customer != false) {
        data.append("customer_id", this.customer);
      }
      return data;
    },
    submitEditForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);
      let data = this.convertToFormData();
      ApiService.post("/fulfillment/asn/parse_asn_skus", data)
        .then((res) => {
          Swal.fire({
            title: this.$t("import_completed"),
            text: this.$t("import_data_parsed"),
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.setData(res.data.data);
          this.toggleModal();
          this.resetEditForm();
        })
        .catch((res) => {
          Swal.fire({
            title: this.$t("notificationtitle_error"),
            text: `${res.data.message}`,
            icon: "error",
            showConfirmButton: false,
            timer: 2500,
          });
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    resetEditForm() {
      this.$v.$reset();
      this.formData.file = null;
    },
  },
  computed: {
    fileErrors() {
      return this.handleFormValidation("file", this);
    },
    exampleFile() {
      return this.$store.getters.getASNExampleFiles.asn_skus_sample_file;
      // return {
      //   type: "rates",
      //   url: "https://apitest.iqfulfillment.com/files/rates/rate.xlsx?v=1656499392",
      //   message:
      //     "The Excel template has been updated. Please, be sure to download a new one.",
      //   need_to_show_message: false,
      // };
    },
  },
};
</script>
